import {Component, inject, OnInit, ViewChild, signal, ChangeDetectionStrategy} from "@angular/core"
import {takeUntilDestroyed} from "@angular/core/rxjs-interop"
import {from} from "rxjs"
import {RouterOutlet} from "@angular/router"
import {CreateItemComponent} from "@common/components/base/create-item.component"
import {CheckboxesFilterComponent, PinnedFilterComponent, PinnedFilterOptionComponent, TagSearchFilterComponent} from "@common/components/filters"
import {ItemFiltersComponent} from "@common/components/item"
import {fetchThrowingErrors} from "@common/helpers/api/fetch"
import {OrganizationsService} from "@common/services/organizations/organizations.service"
import {PermissionsService} from "@common/services/permissions/permissions.service"
import {DialogService} from "@common/services/dialog/dialog.service"
import {Labels, StateLabel} from "@labels"
import {ModelsPageVisibleUsersGQL} from "@pages/models/models-page.generated"
import {AssetsGridComponent} from "@platform/components/assets/assets-grid/assets-grid.component"
import {SelectModelComponent} from "@platform/components/models/select-model/select-model.component"
import {Enums} from "@enums"
import {SidebarLayoutComponent} from "@platform/components/layouts/sidebar-layout/sidebar-layout.component"
import {IsDefined} from "@cm/utils/filter"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-assets-page",
    imports: [
        CheckboxesFilterComponent,
        ItemFiltersComponent,
        RouterOutlet,
        SidebarLayoutComponent,
        PinnedFilterComponent,
        PinnedFilterOptionComponent,
        TagSearchFilterComponent,
        AssetsGridComponent,
    ],
    templateUrl: "./assets-page.component.html",
    styleUrl: "./assets-page.component.scss",
})
export class AssetsPageComponent extends CreateItemComponent implements OnInit {
    readonly Enums = Enums
    readonly Labels = Labels

    readonly organizations = inject(OrganizationsService)
    readonly visibleUsersGql = inject(ModelsPageVisibleUsersGQL)
    readonly dialogService = inject(DialogService)

    readonly permission = inject(PermissionsService)
    $can = this.permission.$to

    @ViewChild(AssetsGridComponent) assetsGrid?: AssetsGridComponent

    readonly $userLabels = signal<StateLabel<string>[] | null>(null)

    ngOnInit() {
        from(fetchThrowingErrors(this.visibleUsersGql)({}))
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(({users}) => {
                this.$userLabels.set(
                    users.filter(IsDefined).map((user) => ({
                        label: user.name,
                        state: user.id,
                    })),
                )
            })
    }

    protected openCreateDialog() {
        this.dialogService.selectInDialog(SelectModelComponent, {
            onSelect: (item) => {
                if (this.assetsGrid) {
                    void this.assetsGrid.createItem({modelId: item.id, organizationId: item.organization?.id})
                }
            },
            onCancel: () => {
                // Navigate back when dialog is cancelled
                this.navigateToParent()
            },
        })
    }
}
